// Objective: Define the service to get the loan leads
import HttpClient from '../http/HttpClient';
import { LEAD_SERVICE_HOST, LEAD_API_PREFIX } from '../constants/RestConstants';
import { PaginationConst } from '../constants/AppConstant';

export async function createDebits(borrowerId:string,releaseObj: Object = {}) {
  const response = await HttpClient.POST({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/borrowers/${borrowerId}/debits`,
    data: releaseObj,
  }); return response;
}

export async function getDebitsByBorrowers(borrowerId:string, pageNumber: number = 0,pageSize:number = PaginationConst.PAGE_SIZE,  filterObj: Object = {}) {
  const response = await HttpClient.GET({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/borrowers/${borrowerId}/debits-insights?page=${pageNumber}&size=${pageSize}`,
  }); return response;
}

export async function updateDebitStatus(borrowerId: string, status: string) {
  const response = await HttpClient.PATCH({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/debits/${borrowerId}/debits`,
    data: { status },
  }); 
  return response;
}

export async function updateIndividualDebitStatus(debitId: string, status: string) {
  const response = await HttpClient.PATCH({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/debits/${debitId}/status`,
    data: { status },
  }); 
  return response;
}
